import React, { useState } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import { SubmitHandler, useForm, get } from "react-hook-form";
import { LOGIN_PAGE, REGISTRATION_SUCCESS_PAGE } from "../../routes";
import { useNavigate } from "react-router";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { CREATE_NEW_USER_URL } from "../../api/apiRoutes";
import { WebUser } from "../../models/WebUser";
import useFacility from "../../../utils/hooks/useFacility";
import { FormElementModel } from "../../models/FormElementModel";
import { userRegisterForm } from "./inputsForm/InputRegisterFormModels";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import EADivider from "../shared/EADivider";
import EATextField from "../shared/TextField/EATextField";
import EAPhoneInput from "../shared/PhoneInput/EAPhoneInput";
import ConsentInputs from "../FinalizePage/ConsentInputs/ConsentInputs";
import EAAlert from "../shared/EAAlert";
import { errorMessageFromApi } from "../../utils/apiErrorMessages";

type Inputs = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  repeatPassword: string;
  phone: string;
  acceptStatute: boolean;
  allowMailing: boolean;
};

const Registration: React.FC = () => {
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<Inputs>({
    defaultValues: {
      acceptStatute: false,
      allowMailing: false,
    },
  });

  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const [, setEmail] = useState<string>();
  const [submitError, setSubmitError] = useState("");

  const handleRegistration: SubmitHandler<Inputs> = async (data) => {
    setEmail(data.email);
    setSubmitError("");
    const webUser: WebUser = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
      phone: data.phone,
      allowMailing: data.allowMailing,
    } as WebUser;
    const response = await post(CREATE_NEW_USER_URL(facilityIds), webUser);
    if (!response.isError) {
      navigate(REGISTRATION_SUCCESS_PAGE);
    } else {
      setSubmitError(errorMessageFromApi(response));
    }
  };

  return (
    <div className="auth-page flex-center-center">
      <div className="auth-box shadow">
        <form onSubmit={handleSubmit(handleRegistration)}>
          <h1>{t("zarejestruj_sie")}</h1>

          <div className="flex-start-center flex-wrap">
            {userRegisterForm(watch, register).map((item: FormElementModel, index: number) => (
              <EATextField
                key={index}
                label={item.text}
                name={item.name}
                type={item.type as "text" | "email" | "password" | "number"}
                register={item.register}
                error={!!get(errors, item.name)}
                helperText={get(errors, item.name)?.message}
                fullWidth
                inputMaxLength={item.inputMaxLength}
              />
            ))}
            <EAPhoneInput
              control={control}
              name="phone"
              errors={errors}
              label={t("telefon_kontaktowy")}
              required
              fullWidth
            />
          </div>

          <ConsentInputs errors={errors} control={control} setValue={setValue} newsletter={true} />

          {submitError && <EAAlert type="error" message={submitError} />}

          <EADivider />

          <div className="buttons flex-between-center">
            <EAButton title={t("wroc_do_logowania")} onClick={() => navigate(LOGIN_PAGE)} variant="outlined" />
            <EAButton title={t("zarejestruj_sie")} inputType="submit" />
          </div>

          {saleConfiguration.message_createNewAccount && saleConfiguration.message_createNewAccount.length > 3 && (
            <div className="alert alert-yellow">
              <article dangerouslySetInnerHTML={{ __html: saleConfiguration.message_createNewAccount }}></article>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Registration;
